export {
  MediaSearchResultFragmentDoc as MediaSearchResultFragment,
  MediaSearchResultFragment as MediaGridFragment,
} from '../schema'
